module.exports = __webpack_public_path__ + "media/images/spotlight-bg-161728753aeab5f518cff1ba921afe31.png";